import { SharedLocale, type SharedLocalizedString } from "../SharedLocale.js";

export const gdprPathMap = {
	[SharedLocale.cs]: "ochrana-osobnich-udaju",
	[SharedLocale.en]: "personal-data-protection",
	[SharedLocale.pl]: "ochrona-danych-osobowych",
	[SharedLocale.sk]: "ochrana-osobnych-udajov",
} satisfies SharedLocalizedString;
